import {
  FETCH_USER_DATA,
  RESET_FETCHED,
  SUBMIT_EMAIL_SUCCESS,
  SUBMIT_EMAIL_FAIL
} from "../actions/userData";
import { PACKAGE_UPDATED } from "../actions/packages";

const initialState = { fetched: false };

const updatePackageWithTrackingInfo = (state, payload) => {
  const newPackages = state.packages;
  const { trackingInfo, packageID, status } = payload;

  // only update tracking for the relevant packageID
  newPackages[status] = newPackages[status].map(pkg => {
    if (pkg.id === packageID) {
      // if tracking info found, add it
      if (trackingInfo) pkg.trackingInfo = trackingInfo;
      // otherwise show error message
      else
        pkg.trackingInfo = {
          carrier_status_description:
            "Unfortunately, no tracking information could be found for this tracking number."
        };
    }
    return pkg;
  });

  return newPackages;
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PACKAGE_UPDATED:
      return {
        ...state,
        packages: updatePackageWithTrackingInfo(state, action.payload)
      };
    case FETCH_USER_DATA:
      const { packages, account, lockers, coupons } = action.payload;
      return {
        ...state,
        packages,
        account,
        lockers,
        coupons,
        fetched: true
      };
    case SUBMIT_EMAIL_SUCCESS:
      return {
        ...state,
        emailSubmitSuccess: true,
        emailSubmitError: undefined
      };
    case SUBMIT_EMAIL_FAIL:
      return {
        ...state,
        emailSubmitSuccess: undefined,
        emailSubmitError: true
      };
    case RESET_FETCHED:
      return {
        ...initialState
      };
    default:
      return state;
  }
};
